// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#alcor-modal-component .el-dialog__body,#alcor-modal-component .el-dialog__footer,#alcor-modal-component .el-dialog__header{padding:0}#alcor-modal-component .el-dialog{border:var(--border-1);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}#alcor-modal-component .el-dialog__body{padding:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
